<h1 class="display">Set a new password</h1>
<section class="ctx-card">
  <section class="ctx-card__content">
    <form
      class="flex flex-col gap-4 py-2"
      [formGroup]="formGroup"
      (ngSubmit)="reset()"
    >
      @if (showApiMessage) {
      <ctx-alert [alertLevel]="apiMessage.alertLevel">{{
        apiMessage.text
      }}</ctx-alert>
      }
      <section class="flex flex-col gap-4">
        <mat-form-field>
          <mat-label>New Password</mat-label>
          <input
            matInput
            type="password"
            formControlName="newPassword"
            autocomplete="new-password"
          />
          <mat-error>{{ getControlError(formGroup, 'newPassword') }}</mat-error>
        </mat-form-field>
      </section>
      <button
        ctx-button--primary
        type="submit"
        [disabled]="formStates.disabled"
        [loading]="formStates.submit"
        type="submit"
      >
        Reset Password
      </button>
    </form>
  </section>
</section>
